module.exports = __webpack_public_path__ + "img/satelite-realtime.bff1eb6b.svg";